import { useCallback } from 'react';

import * as pas from 'js/hooks/auth/pas';
import { useContinueLoginWithSessionToken } from 'js/hooks/auth/hooks/useContinueLoginWithSessionToken';

export const useContinueLogin = () => {
    const continueLoginWithSessionToken = useContinueLoginWithSessionToken();

    return useCallback(async ({
        credentials,
        afterRegisterLogin,
        isAfterLoginWithCredentials,
        isLoginToNativeAppEnabled,
        isAutoLogin
    }) => {
        const { data: { sessionToken: { sessionToken } } } = await pas.getTempToken();

        await continueLoginWithSessionToken({
            ...credentials,
            sessionToken,
            afterRegisterLogin,
            isAfterLoginWithCredentials,
            isLoginActionPrevented: false,
            isLoginToNativeAppEnabled,
            isAutoLogin
        });
    }, [continueLoginWithSessionToken]);
};
